/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Status_GeneratedInputs */

const en_po_status_generated = /** @type {(inputs: Po_Status_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To approve`)
};

/**
* | output |
* | --- |
* | "To approve" |
*
* @param {Po_Status_GeneratedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_status_generated = /** @type {((inputs?: Po_Status_GeneratedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Status_GeneratedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_status_generated(inputs)
});